export enum TemplateInsightViews {
  Overview = 'overview',
  ByTemplate = 'by_template',
  TrackedVsPlanned = 'time_tracked_vs_planned',
}

export const TemplateInsightSubTask = {
  [TemplateInsightViews.Overview]: ['template', 'phases', 'tasks'],
  [TemplateInsightViews.ByTemplate]: ['project', 'phases', 'tasks'],
  [TemplateInsightViews.TrackedVsPlanned]: ['templates', 'tasks'],
};
